import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enApiData from './english/api-data.json';
// English translations
import enClients from './english/clients.json';
import enCommon from './english/common.json';
import enDashboard from './english/dashboard.json';
import enEquipment from './english/equipment.json';
import enFacilities from './english/facilities.json';
import enNavigation from './english/navigation.json';
// French-Canadian translations
import fcClients from './french-canadian/clients.json';
import fcCommon from './french-canadian/common.json';
import fcDashboard from './french-canadian/dashboard.json';
import fcEquipment from './french-canadian/equipment.json';
import fcFacilities from './french-canadian/facilities.json';
import fcNavigation from './french-canadian/navigation.json';

export const resources = {
  en: {
    ...enCommon,
    ...enNavigation,
    ...enDashboard,
    ...enClients,
    ...enEquipment,
    ...enFacilities,
    ...enApiData,
  },
  fc: {
    ...fcCommon,
    ...fcNavigation,
    ...fcDashboard,
    ...fcClients,
    ...fcEquipment,
    ...fcFacilities,
  },
};

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: [
      'common',
      'language',
      'navigation',
      'dashboard',
      'client',
      'contacts',
      'documents',
      'statements',
      'commissions',
      'user',
      'equipment',
      'facility',
      'apiData',
    ];
    keySeparator: false;
    resources: typeof resources.en;
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    keySeparator: false,
    ns: Object.keys(resources.en),
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
